import { ajaxActions } from 'common/ajax/store.js';
import { basePath } from 'common/config.js';

const ACCOUNT_ADDED = 'ACCOUNT_ADDED';
const GET_DATA = 'GET_DATA';

const initialState = {
  accounts: null,
  data: null,
};

export const actionCreators = {
  addAccount: (adfitNo, handleRedirect) => async (dispatch) => {
    let url = `${basePath}/api/user/accounts`;
    dispatch(
      ajaxActions.sendAjaxRequest(
        url,
        'POST',
        (result) => {
          dispatch({ type: ACCOUNT_ADDED, result: result });
          handleRedirect(result);
        },
        JSON.stringify({ adfitNo: adfitNo })
      )
    );
  },
  getTestData: () => {
    // setTimeout(() => {
    //   return { type: GET_DATA };
    // }, 2000);
    return { type: GET_DATA };
  },
};

export const reducer = (state, action) => {
  state = state || initialState;
  // if (action.type === ACCOUNT_ADDED) {
  //   const result = { ...state };
  //   result.accounts = action.result;
  //   return result;
  // }
  if (action.type === GET_DATA) {
    let result = {};
    result.data = {
      adfitNo: 'abc123',
      gender: '2',
      accept: true,
      colors: null, //"red",
      date: '12/12/1990',
    };
    return result;
  }
  return state;
};
